import axios from 'axios';
import { API_BASE_PATH } from '../environment';
import qs from 'qs';
import { ReactNode } from 'react';
 
const BASE_URL = `${API_BASE_PATH}`;
 
 export interface Client {
   client_id: string;
  client_name: string;
}
 
export interface Plan {
 
  plan_id?: string;
  plan_name: string;
  plan_type: string;
 
}
 
 
export interface Payment {
  status: string;
  client_id: string;
  plan_id: string;
  payment_date: string;
  Expire_date: string;
  amount: number;
  transaction_id: string | null;
  payment_method: string;
  payment_id: string;
}
 
export const getPaymentById = async (payment_id: string): Promise<Payment> => {
  try {
    const response = await axios.get<Payment>(`${API_BASE_PATH}/payments/${payment_id}`, {
      headers: {
       
        'accept': 'application/json',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error(`Error fetching payment with ID ${payment_id}:`, error?.response?.data || error.message);
    throw error;
  }
};
 
//get all
 
export interface PaymentResponse {
  status: string;
  client_id: string;
  plan_id: string;
  payment_date: string;
  Expire_date: string;
  amount: number;
  transaction_id: string | null;
  payment_method: string;
  payment_id: string;
}
 
 
export const getAllPayments = async (): Promise<PaymentResponse[]> => {
  try {
    const response = await axios.get<PaymentResponse[]>(`${API_BASE_PATH}/payments/`, {
      headers: {
        'accept': 'application/json',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error('Error fetching all payments:', error);
    throw error;
  }
};
 
//post
export interface CreatePaymentRequest {
  client_id: string;
  plan_id: string;
  amount: number;
  payment_date: string;
  Expire_date: string;
  payment_method: string;
  status: string;
}
 
 
export const createPayment = async (data: CreatePaymentRequest): Promise<PaymentResponse> => {
  try {
    const response = await axios.post<PaymentResponse>(
      `${API_BASE_PATH}/payments/`,
      qs.stringify(data),
      {
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error('Error creating payment:', error);
    throw error;
  }
};
 
 
export interface Payment {
  status: string;
  client_id: string;
  plan_id: string;
  payment_date: string;
  Expire_date: string;
  amount: number;
  transaction_id: string | null;
  payment_method: string;
  payment_id: string;
}
 
//put
 
 
export interface UpdatePaymentRequest {
  client_id: string;
  amount: number;
  payment_date: string;
  Expire_date: string;
  payment_method: string;
  status: string;
}
 
export const updatePayment = async (
  payment_id: string,
  data: UpdatePaymentRequest
): Promise<PaymentResponse> => {
  try {
    const response = await axios.put<PaymentResponse>(
      `${API_BASE_PATH}/payments/${payment_id}`,
      qs.stringify(data),
      {
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error('Error updating payment:', error);
    throw error;
  }
};
 
 
// delete
export interface DeletePaymentResponse {
  message: string;
}
export const deletePayment = async (payment_id: string): Promise<DeletePaymentResponse> => {
  try {
    const response = await axios.delete<DeletePaymentResponse>(
      `${API_BASE_PATH}/payments/${payment_id}`,
      {
        headers: {
          accept: 'application/json',
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error('Error deleting payment:', error);
    throw error;
  }
};